import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Error {
  response: {
    status: number
    data: {
      message: string
    }
  }
}

export enum RestrictionsStatus {
  NO_RESTRICTION = 'NO_RESTRICTION',
  PATIENT_ALREADY_HAS_RESERVATION = 'PATIENT_ALREADY_HAS_RESERVATION',
  ONLY_PARTICULAR_PLAN_ALLOW_RESERVATION = 'ONLY_PARTICULAR_PLAN_ALLOW_RESERVATION',
  NO_PLAN_GROUP_ALLOWS_RESERVATION = 'NO_PLAN_GROUP_ALLOWS_RESERVATION',
  PATIENT_ALREADY_HAS_SCHEDULE = 'PATIENT_ALREADY_HAS_SCHEDULE',
}

interface PatientRestrictionsProps {
  username: string
  planCode: string
}

interface DataAPI {
  only_particular: boolean
  scheduled_schedule_count: number
}

interface PatientRestrictionsData {
  restrictionStatus: keyof typeof RestrictionsStatus | string
  scheduledScheduleCount: number
}

export const patientRestrictions = ({
  username,
  planCode
}: PatientRestrictionsProps): Promise<PatientRestrictionsData> => {

  const params = {
    ...(planCode && { plan_code: planCode }),
  }

  const endpoint = apiEndpoints.RESTRICTIONS_PATIENT(username)
  
  return new Promise<PatientRestrictionsData> ((resolve, reject) => {
    axios.get<DataAPI>(endpoint, {
      params
    })
      .then(({ data }) => {
        if (data.only_particular) {
          resolve({
            restrictionStatus: RestrictionsStatus.ONLY_PARTICULAR_PLAN_ALLOW_RESERVATION,
            scheduledScheduleCount: data.scheduled_schedule_count,
          })
        } else {
          resolve({
            restrictionStatus: RestrictionsStatus.NO_RESTRICTION,
            scheduledScheduleCount: data.scheduled_schedule_count,
          })
        }
      })
      .catch((error: Error) => {
        const status = error.response.status
        const message = error.response.data.message
        
        if (status === 403) {
          if (message === 'patient_already_has_reservation') {
            resolve({
              restrictionStatus: RestrictionsStatus.PATIENT_ALREADY_HAS_RESERVATION,
              scheduledScheduleCount: 0,
            })
          }

          if (message === 'no_plan_group_allows_reservation') {
            resolve({
              restrictionStatus: RestrictionsStatus.NO_PLAN_GROUP_ALLOWS_RESERVATION,
              scheduledScheduleCount: 0,
            })
          }

          resolve({
            restrictionStatus: message,
            scheduledScheduleCount: 0,
          })
        }

        reject(error.response.status)
      })
  })
}